import { useState } from 'react'
import { Typography, Box, Divider, Alert, Link, Button } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { SignupForm } from 'src/components/SignupForm'
import { SocialAuth } from 'src/components/SocialAuth'
import { useAuth } from 'src/contexts/AuthContext'
import backgroundImage from 'src/images/background/sign_background.svg'

export function SignupPage() {
  const [error, setError] = useState<string>()
  const { user, loading } = useAuth()

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* Left */}
      <Box
        sx={{
          flex: '1 1 50%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          px: { xs: 3, sm: 5 },
          py: 4,
          backgroundColor: 'white'
        }}>
        <Box sx={{ width: '100%', maxWidth: 360 }}>
          <Typography sx={{ fontWeight: 800, fontSize: '1.2rem', color: '#4277b9', mb: 6, textAlign: 'center' }}>
            BatiKal
          </Typography>

          {loading ? (
            <Typography sx={{ textAlign: 'center', color: '#64748b' }}>Chargement…</Typography>
          ) : user ? (
            <>
              <Typography variant="h5" sx={{ fontWeight: 700, color: '#1e293b', mb: 2, textAlign: 'center' }}>
                Compte prêt
              </Typography>
              <Typography variant="body2" sx={{ color: '#64748b', mb: 2, textAlign: 'center', lineHeight: 1.6 }}>
                Vous êtes connecté avec <strong>{user.email ?? user.uid}</strong>.
                {!user.emailVerified && (
                  <>
                    {' '}
                Un e-mail de vérification a normalement été envoyé (vérifiez les courriers indésirables).
                  </>
                )}
              </Typography>
              <Button
                component={RouterLink}
                to="/dashboard"
                variant="contained"
                fullWidth
                disableElevation
                sx={{
                  py: 1.5,
                  borderRadius: '24px',
                  fontWeight: 600,
                  textTransform: 'none',
                  backgroundColor: '#4277b9',
                  '&:hover': { backgroundColor: '#3666a3' }
                }}>
                Ouvrir le tableau de bord
              </Button>
            </>
          ) : (
            <>
              <Typography variant="h5" sx={{ fontWeight: 700, color: '#1e293b', mb: 4, textAlign: 'center' }}>
                Inscription
              </Typography>

              <SocialAuth setError={setError} />

              <Divider sx={{ my: 3 }}>
                <Typography variant="caption" sx={{ color: '#cbd5e1' }}>
                  ou
                </Typography>
              </Divider>

              <SignupForm setError={setError} />

              <Typography variant="body2" sx={{ textAlign: 'center', mt: 3, color: '#64748b' }}>
                Déjà un compte ?{' '}
                <Link
                  component={RouterLink}
                  to="/login"
                  sx={{ color: '#4277b9', fontWeight: 600, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>
                  Se connecter
                </Link>
              </Typography>
            </>
          )}

          {error && <Alert severity="error" sx={{ mt: 2, borderRadius: '8px', fontSize: '0.85rem' }}>{error}</Alert>}
        </Box>

        <Typography variant="caption" sx={{ color: '#cbd5e1', mt: 'auto', pt: 4 }}>
          &copy; BatiKal {new Date().getFullYear()}
        </Typography>
      </Box>

      {/* Right */}
      <Box
        sx={{
          flex: '1 1 50%',
          display: { xs: 'none', md: 'block' },
          background: `url(${backgroundImage}) center / cover no-repeat`
        }}
      />
    </Box>
  )
}
